




























































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import qrCode from "./Qrcode/index.vue";
import headerTitle from "@/components/header.vue";
import {
  CheckUser,
  UserGames,
  ServerList,
  RoleList,
  BoxPayGrade,
  getPayInfo,
} from "@/req/pay";
@Component({
  components: {
    qrCode,
    headerTitle,
  },
})
export default class Home extends Vue {
  public account = ""; // 当前输入账号
  public lastAccount = ""; // 上次输入账号
  public payItemListData: any = []; // 充值币种
  public payGrade: any = []; // 充值档位
  public otherMoney: any = "";
  public showMoreNum: any = "";
  public gameList: any = [];
  public serverList: any = [];
  public roleList: any = [];
  public inputStatus = false;
  public numStatus = false;
  public imgUrl = [
    {
      payName: "支付宝扫码",
      payImgLogo: require("@/assets/icons/Alipay.png"),
      payUnits: "元",
    },
    {
      payName: "微信扫码",
      payImgLogo: require("@/assets/icons/WehcatPay.png"),
      payUnits: "元",
    },
    {
      payName: "需支付",
      payUnits: "盒币",
    },
    {
      payName: "需支付",
      payUnits: "金币",
    },
  ];
  public boxName = {
    // 游戏选区
    boxGameId: "",
    gameName: "",
    // 区服列表
    serverid: "",
    serverName: "",
    // 选择角色
    roleid: "",
    roleName: "",
    uid: "", //  用户id
    payMoney: "", // 支付费用
    payKind: {},
    activeWay: null,
    activeCredit: null,
    activeGameItem: null,
    accountStatus: false,
    grade_id: ''
  };
  // 支付方式
  public payWay = [
    {
      pay_id: 0,
      name: "支付宝",
    },
    {
      pay_id: 1,
      name: "微信",
    },
    {
      pay_id: 2,
      name: "盒币",
    },
    {
      pay_id: 3,
      name: "金币",
    },
  ];
  public timeID: any = null;
  public ms = 500;
  public qrCodeStatus = false;
  @Prop({ default: "", type: String }) private gameId;
  @Watch("gameId")
  public gameIdChange() {
    setTimeout(() => {
      (this as any).boxName.boxGameId = Number(this.gameId);
      this.gameList.forEach((element) => {
        if (this.gameId == element.box_game_id) {
          this.boxGameChange({
            label: element.game_name,
            value: element.box_game_id,
          });
        }
      });
    }, 500);
  }
  @Watch("qrCodeState", { immediate: true, deep: true })
  public boxNameChange(newL, oldL) {
    if (newL !== oldL) {
      this.ms = 500;
      clearTimeout(this.timeID);
      this.timeID = setTimeout(() => {
        this.qrCodeStatus = newL;
      }, this.ms);
    }
  }
  get qrCodeState() {
    return (
      this.boxName.activeWay != null &&
      this.boxName.payMoney != "" &&
      this.boxName.activeGameItem != null &&
      this.boxName.roleid != "" &&
      this.boxName.accountStatus == true
    );
  }
  public created() {
    this.account = this.lastAccount = JSON.parse(
      JSON.stringify(this.$store.state.user.info.account)
    );
  }
  public mounted() {
    this.judge();
  }
  // 用户信息判断
  public async judge() {
    if (this.account != this.lastAccount) {
      this.gameList = [];
      this.boxName.boxGameId = "";
      this.boxName.gameName = "";
      this.serverList = [];
      this.boxName.serverid = "";
      this.boxName.serverName = "";
      this.roleList = [];
      this.boxName.roleid = "";
      this.boxName.roleName = "";
      this.payItemListData = [];
      this.payGrade = [];
      this.boxName.activeWay = this.boxName.activeGameItem = this.boxName.activeCredit = null;
    }
    const res = await CheckUser({
      token: this.$fn.cookies.getToken("token"),
      account: this.account,
    });
    if (res.code == 200) {
      this.boxName.uid = res.data.role_info.id;
      this.lastAccount = this.account;
      this.boxName.accountStatus = true;
      this.gameChange();
    } else {
      this.boxName.accountStatus = false;
      this.$Message.error(res.msg);
    }
  }
  // 获取游戏选取列表
  public async gameChange() {
    const res = await UserGames({
      token: this.$fn.cookies.getToken("token"),
      uid: this.boxName.uid,
    });
    if (res.code === 200) {
      this.gameList = res.data.game_list;
    }
  }
  // 玩家区服列表
  public async boxGameChange(e) {
    this.serverList = [];
    this.boxName.serverid = "";
    this.boxName.serverName = "";
    this.roleList = [];
    this.boxName.roleid = "";
    this.boxName.roleName = "";
    this.boxName.gameName = e.label;
    this.boxName.payKind = {};
    this.boxName.activeWay = this.boxName.activeGameItem = this.boxName.activeCredit = null;
    const res = await ServerList({
      token: this.$fn.cookies.getToken("token"),
      game_id: e.value,
      uid: this.boxName.uid,
    });
    if (res.code === 200) {
      this.serverList = res.data;
    }
  }
  // 选取角色
  public async boxRoleChange(e) {
    this.roleList = [];
    this.boxName.roleid = "";
    this.boxName.roleName = "";
    this.boxName.serverName = e.label;
    const obj = {
      token: this.$fn.cookies.getToken("token"),
      game_id: this.boxName.boxGameId,
      server_id: e.value,
      account: this.account,
    };
    const res = await RoleList(obj);
    if (res.code === 200) {
      this.roleList = res.data.role_list;
    }
  }
  // 获取角色title
  public boxRoleName(e) {
    this.boxName.roleName = e.label;
    this.gamePayGrade();
  }
  // 游戏充值档位
  public async gamePayGrade() {
    const res = await getPayInfo({
      token: this.$fn.cookies.getToken("token"),
      game_id: this.boxName.boxGameId,
    });
    if (res.code == 200) {
      this.payItemListData = res.data.pay_config;
      this.payGrade = res.data.pay_grade;
      this.showMoreNum = res.data.show_more_num;
    }
  }
  // 充值币种判断
  public payGameGold(index, item) {
    if (this.boxName.activeGameItem == index) {
      this.boxName.activeGameItem = null;
      this.boxName.payKind = {};
    } else {
      this.boxName.activeGameItem = index;
      this.boxName.payKind = item;
    }
  }
  // 充值货币转换
  public payCredit(index, item) {
    this.otherMoney = "";
    this.inputStatus = false;
    this.numStatus = false;
    this.boxName.accountStatus = false;
    if (this.boxName.activeCredit == index) {
      this.boxName.payMoney = "";
      this.boxName.activeCredit = null;
      this.boxName.grade_id = '';
    } else {
      this.boxName.activeCredit = index;
      this.boxName.payMoney = item.money + "";
      this.boxName.accountStatus = true;
      this.boxName.grade_id = item.grade_id;
    }
  }
  // 获取输入数量
  public otherChange() {
    this.boxName.activeCredit = null;
    this.boxName.grade_id = '';
    this.boxName.payMoney = this.otherMoney;
  }
  // 正则校验
  public clearBlank() {
    this.otherMoney = this.otherMoney
      .replace(/[^\d]/g, "")
      .replace(/^0{1,}/g, "");
  }
  // 支付状态判断
  public paycomWay(index) {
    if (this.boxName.activeWay == index) {
      this.boxName.activeWay = null;
    } else {
      this.boxName.activeWay = index;
    }
  }
  public serverChange() {
    if (this.boxName.serverid == undefined) {
      this.boxName.serverid = "";
    }
    if (this.boxName.boxGameId == undefined) {
      this.boxName.boxGameId = "";
    }
    if (
      this.boxName.activeWay != null &&
      this.boxName.activeCredit != null &&
      this.boxName.activeGameItem != null &&
      this.boxName.boxGameId != "" &&
      this.boxName.serverid == ""
    ) {
      return true;
    } else {
      return false;
    }
  }
  public roleChange() {
    if (this.boxName.roleid == undefined) {
      this.boxName.roleid = "";
    }
    if (this.boxName.boxGameId == undefined) {
      this.boxName.boxGameId = "";
    }
    if (
      this.boxName.activeWay != null &&
      this.boxName.activeCredit != null &&
      this.boxName.activeGameItem != null &&
      this.boxName.boxGameId != "" &&
      this.boxName.roleid == ""
    ) {
      return true;
    } else {
      return false;
    }
  }
  // 判断是否输入值
  public blurChange() {
    if (this.otherMoney == "" && this.boxName.activeCredit == null) {
      this.inputStatus = true;
      this.numStatus = false;
    } else {
      this.inputStatus = false;
      this.numStatus = true;
      this.boxName.accountStatus = true;
    }
  }
  public foucsChange() {
    this.boxName.accountStatus = false;
    if (this.otherMoney == "") {
      this.boxName.payMoney = "";
    }
    this.boxName.activeCredit = null;
    if (!this.numStatus) {
      this.numStatus = true;
    }
  }
}
